import React from "react";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const ScoreCircle = ({ score }) => {
  function getColor(score) {
    if (score <= 20) return "#D93726";
    if (20 <= score && score < 40) return "#EF7E1A";
    if (40 <= score && score < 60) return "#F5C100";
    if (60 <= score && score < 80) return "#2ECC71";
    if (80 <= score) return "#169A6A";
    return "#169A6A";
  }

  return (
    <>
      <div>
        <CircularProgressbar
          value={score}
          maxValue={100}
          minValue={0}
          // text={`${score}/100`}
          background={false}
          styles={buildStyles({
            pathColor: getColor(score),
            textSize: "24px",
            textColor: "black",
            trailColor: "#F3F5F7",
          })}
        />
        <div className="relative top-[-44px] flex justify-center align-middle items-end">
          <p className=" text-lg font-Poppins-SemiBold">{`${score}`}</p>
          <p className=" font-Poppins-Light text-[8px]">{`/100`}</p>
        </div>
      </div>
    </>
  );
};

export default ScoreCircle;
